import { Controller } from "@hotwired/stimulus"
import { makeMatcher } from "../utils/text_match"

// Filters the dropdown menu of saved views by name. The dropdown itself is
// driven by the generic "dropdown" controller (open/close).
export default class extends Controller {
  static targets = ["menuItem", "menuList", "sectionLabel", "empty"]

  filterMenu(event) {
    const matcher = makeMatcher(event.currentTarget.value)
    let visible = 0

    this.menuItemTargets.forEach(item => {
      const name = item.dataset.name || ""
      const match = matcher(name)
      item.style.display = match ? "" : "none"
      if (match) visible++
    })

    // Hide section labels whose group has no visible items (the labels
    // immediately precede their items in the DOM).
    this.sectionLabelTargets.forEach(label => {
      let next = label.nextElementSibling
      let hasVisible = false
      while (next && !next.classList.contains("sv-tabs__more-section-label")) {
        if (next.style.display !== "none") { hasVisible = true; break }
        next = next.nextElementSibling
      }
      label.style.display = hasVisible ? "" : "none"
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.hidden = visible > 0
    }
  }
}
